import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { Session } from "@/api/auth";

export type SessionStoreState = {
  session: Session | null;
  setSession: (session: Session | null) => void;
};

export const useSessionStore = create<SessionStoreState>()(
  persist(
    (set) => {
      return {
        session: null,
        setSession: (session: Session | null) => {
          set(() => {
            return { session };
          });
        },
      };
    },
    {
      name: "sessionStore",
    },
  ),
);

export const getSessionStoreState = () => {
  return useSessionStore.getState();
};
